import React, { useEffect, useRef } from 'react';
import { RouterProvider } from 'react-router-dom';

import * as AuthModule from 'modules/auth';
import { NotificationsSocketBridge } from 'modules/notifications';
import { router, LoadingScreen } from './router';
import {
  GOOGLE_ANALYTICS_MEASUREMENT_ID,
  INITIAL_LOCATION_SEARCH,
  isGoogleAnalyticsMeasurementId,
  trackPageView,
} from './lib/analytics';

const App: React.FC = () => {
  AuthModule.Hooks.useProfile();
  const { state: { isInitialized } } = AuthModule.Context.useAuthContext();
  const trackedPathname = useRef<string>();

  useEffect(() => {
    if (!isGoogleAnalyticsMeasurementId(GOOGLE_ANALYTICS_MEASUREMENT_ID)) {
      return;
    }

    const trackLocation = (pathname: string, search = '') => {
      if (trackedPathname.current === pathname) {
        return;
      }

      trackedPathname.current = pathname;
      trackPageView(GOOGLE_ANALYTICS_MEASUREMENT_ID, pathname + search);
    };

    trackLocation(window.location.pathname, INITIAL_LOCATION_SEARCH);

    return router.subscribe((state) => {
      if (state.navigation.state === 'idle') {
        trackLocation(state.location.pathname);
      }
    });
  }, []);

  if (!isInitialized) {
    return <LoadingScreen />;
  }

  return (
    <>
      <NotificationsSocketBridge />
      <RouterProvider router={router} />
    </>
  );
};

export default App;
